import {ForecastItemForm} from 'modules/project'
import {Modal} from 'common/components'
import {SetNewForecast, ForecastFormItem} from 'common/types'

interface RequestForecastModalProps {
  open: boolean
  projectUuid: string
  requestUuid: string
  minDate: Date
  forecastItem?: ForecastFormItem
  itemDate?: Date
  loanValue: number
  forecast: ForecastFormItem[]
  setNewForecast?: SetNewForecast
  onClose: () => void
}

export default function RequestForecastModal({
  open,
  projectUuid,
  requestUuid,
  minDate,
  forecastItem,
  itemDate,
  loanValue,
  forecast,
  setNewForecast,
  onClose,
}: RequestForecastModalProps) {
  return (
    <Modal
      width={486}
      open={open}
      title={`${forecastItem ? 'Edit' : 'Add'} forecast item`}
      onCancel={onClose}
    >
      <ForecastItemForm
        projectUuid={projectUuid}
        requestUuid={requestUuid}
        minDate={minDate}
        forecastItem={forecastItem}
        itemDate={itemDate}
        loanValue={loanValue}
        forecast={forecast}
        setNewForecast={setNewForecast}
        onClose={onClose}
      />
    </Modal>
  )
}
